import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  type: "info"
}
const _hoisted_9 = { class: "action-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.keyword,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.keyword) = $event)),
        placeholder: "用户名",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: _ctx.filters.group_id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.group_id) = $event)),
        placeholder: "角色",
        filterable: "",
        clearable: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupList, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.title,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.brand_name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.brand_name) = $event)),
        placeholder: "品牌",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.channel_no,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.channel_no) = $event)),
        placeholder: "渠道",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: _ctx.filters.user_type,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.user_type) = $event)),
        placeholder: "用户类型",
        filterable: "",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            value: 4,
            label: "全部"
          }),
          _createVNode(_component_el_option, {
            value: 1,
            label: "蛋叔员工"
          }),
          _createVNode(_component_el_option, {
            value: 2,
            label: "合作商户"
          }),
          _createVNode(_component_el_option, {
            value: 3,
            label: "渠道方"
          }),
          _createVNode(_component_el_option, {
            value: 5,
            label: "供应商"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.search()))
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "filter-item",
        to: '/permission/user/edit'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("添加")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      border: "",
      "default-expand-all": "",
      "row-key": "id",
      "tree-props": {children: 'children', hasChildren: 'hasChildren'},
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "用户ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "username",
          label: "用户名"
        }),
        _createVNode(_component_el_table_column, {
          prop: "user_type",
          label: "用户类型"
        }, {
          default: _withCtx((scope) => [
            (scope.row.user_type == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "蛋叔员工"))
              : _createCommentVNode("", true),
            (scope.row.user_type == 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "合作商户"))
              : _createCommentVNode("", true),
            (scope.row.user_type == 3)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "渠道方"))
              : _createCommentVNode("", true),
            (scope.row.user_type == 5)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "供应商"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "phone",
          label: "手机号",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "channel_no",
          label: "渠道"
        }),
        _createVNode(_component_el_table_column, {
          prop: "email",
          label: "邮箱"
        }),
        _createVNode(_component_el_table_column, {
          prop: "group",
          label: "角色"
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, { label: "状态" }, {
          default: _withCtx((scope) => [
            (scope.row.status == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "开通"))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, "禁用"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_9, [
              (scope.row.status == 1)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (_ctx.onEdit(scope.row.id))
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("编辑")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (scope.row.group_id != 1)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (_ctx.changeStatus(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.status==1 ? '禁用': '开通'), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_Pagination, {
      currentPage: _ctx.filters.page,
      total: _ctx.total,
      onPageChange: _ctx.onPageChange,
      onSizeChange: _ctx.onSizeChange
    }, null, 8, ["currentPage", "total", "onPageChange", "onSizeChange"])
  ]))
}